import UseAuthContext from 'context/AuthContext';
import { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { USER_ROLES } from 'utils/constants';
import { AdminMenus } from 'utils/utils';

const ProtectedRoute = (props: any) => {
  const { isAuthenticated, user, auth, logout, role } =
    useContext(UseAuthContext);
  const location = useLocation();

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?redirect=${redirect}`} replace />;
  }

  if (isAuthenticated && role === USER_ROLES.ADMIN && AdminMenus.some((adminMenu: any) => location.pathname.includes(adminMenu.path)))  {
    localStorage.removeItem('organizationId');
    localStorage.removeItem('organizations');
  }

  return props.children;
};

export default ProtectedRoute;
